import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import koLocale from 'date-fns/locale/ko'
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { GridRenderCellParams, DataGridPremium, GridRowsProp, GridColDef, GridToolbar, useGridApiRef, GridFilterModel } from '@mui/x-data-grid-premium';
import { eachDayOfInterval } from 'date-fns';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { createStyles, makeStyles } from '@mui/styles';
import styles from '../../componentsStyle/upload.module.css';
import { createTheme, darken, lighten } from '@mui/material/styles';
import { Backdrop, Button, CircularProgress, SwipeableDrawer, ToggleButton, ToggleButtonGroup, Badge } from '@mui/material';
import { Button as Button2 } from '@mui/joy';
import totalLocationData from '../../../data/locationdata';
import { Add, Check, Close } from '@mui/icons-material';
import { postFetch } from '../../../fetch/fetch';
import ChatForOpinion from './chatforOpinion';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { ReactComponent as Comment } from "../../../svg/comment-light.svg";
import ImageIcon from '@mui/icons-material/Image';
import ImageModal2 from '../use/imagemodal2';

// switch (each.kindValue) {
//   case "live":
//       oneRow.kind = "생활";
//       break;
//   case "change":
//       oneRow.kind = "자리변경";
//       break;
//   case "consult":
//       oneRow.kind = "담임상담";
//       break;
//   case "question":
//       oneRow.kind = "질의응답";
//       break;
//   case "coaching":
//       oneRow.kind = "과외";
//       break;
//   case "ceo":
//       oneRow.kind = "대표에게";
//       break;
//   case "etc":
//       oneRow.kind = "기타";
//       break;
// }

export const opinionKinds = [
  { lable: "생활", value: "live", exceptAcademy: ["alltarget"] },
  { lable: "자리변경", value: "change", exceptAcademy: ["alltarget"] },
  { lable: "담임상담", value: "consult", exceptAcademy: ["alltarget"] },
  { lable: "질의응답", value: "question" },
  { lable: "과외", value: "coaching", exceptAcademy: ["alltarget"] },
  { lable: "대표에게", value: "ceo", exceptAcademy: ["alltarget"] },
  { lable: "기타", value: "etc" },
  { lable: "학습관 생활 관리", value: "studylive", academies: ["alltarget"] },
  { lable: "학습 상담", value: "studyconsult", academies: ["alltarget"] },
  { lable: "멘탈 케어", value: "mentalcare", academies: ["alltarget"] },
];


const defaultTheme = createTheme();
const useStyles2 = makeStyles(
  (theme) => {
    const getBackgroundColor = (color: any) =>
      theme.palette.mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getHoverBackgroundColor = (color: any) =>
      theme.palette.mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

    return {
      root: {
        '& .super-app-theme--처리완료': {
          backgroundColor: getBackgroundColor(theme.palette.info.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
          },
        },
        '& .super-app-theme--Filled': {
          backgroundColor: getBackgroundColor(theme.palette.success.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
          },
        },
        '& .super-app-theme--확인': {
          backgroundColor: getBackgroundColor(theme.palette.warning.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.warning.main),
          },
        },
        '& .super-app-theme--미확인': {
          backgroundColor: getBackgroundColor(theme.palette.error.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
          },
        },
      },
    };
  },
  { defaultTheme },
);




interface GridCellExpandProps {
  value: string;
  width: number;
}


const useStyles = makeStyles(() =>
  createStyles({
    root: {
      alignItems: 'center',
      lineHeight: '24px',
      width: '100%',
      height: '100%',
      position: 'relative',
      display: 'flex',
      '& .cellValue': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  }),
);


function isOverflown(element: Element): boolean {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}


const GridCellExpand = React.memo(function GridCellExpand(
  props: GridCellExpandProps,
) {
  const { width, value } = props;
  const wrapper = React.useRef<HTMLDivElement | null>(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const classes = useStyles();
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current!);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent: KeyboardEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <div
      ref={wrapper}
      className={classes.root}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        ref={cellDiv}
        style={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <div ref={cellValue} className="cellValue">
        {value}
      </div>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current!.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8 }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </div>
  );
});

function renderCellExpand(params: GridRenderCellParams<any>) {
  return (
    <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
  );
}





const Totalsearch: React.FC<any> = (props) => {
  const classes = useStyles2();
  const [rows, setRows] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [editRowsModel, setEditRowsModel] = React.useState({});
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [
      { id: 2, field: "location", operator: "contains", value: "" }
    ]
  })
  const [alignment, setAlignment] = useState("전체");
  const [update, setUpdate] = useState(0);
  const [open3, setOpen3] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedId, setSelectedId] = useState(0);
  const [imageSrc, setImageSrc] = useState("");
  const [open5, setOpen5] = useState(false);

  const columns: GridColDef[] = [
    {
      field: "responsible", headerName: "책임자", width: 70, renderCell: (params: any) => {

        const value = params.value;
        const id = params.id;

        //띄어쓰기 이전 value만
        var simpleValue = "";

        if (value) {
          simpleValue = value.split(" ")[0];
        }

        const submit = async () => {

          if (!id) {
            return;
          }

          if (!props.user) {
            return;
          }

          if (!props.user.todoistApiKey && props.user.academy === "sunbae") {
            return;
          }

          setLoading(true);

          try {

            const result: any = await postFetch("/dashboard/search/responsible", {
              id
            });

            setLoading(false);

            if (result.message === "success") {
              const userName = result.userName;
              var simpleUserName = "";
              if (userName) {
                simpleUserName = userName.split(" ")[0];
              }

              //해당 id를 가진 rows의 responsible을 userName으로 변경
              setRows((prevRows: any) => {
                return prevRows.map((row: any) => {
                  if (row.id === id) {
                    return { ...row, responsible: simpleUserName };
                  }
                  return row;
                });
              });
            }


          } catch (e) {
            console.error(e);
          }
        }

        const cancel = async () => {
          if (!id) {
            return;
          }

          setLoading(true);

          try {

            const result: any = await postFetch("/dashboard/search/responsiblecancel", {
              id
            });

            setLoading(false);

            if (result.message === "success") {
              setRows((prevRows: any) => {
                return prevRows.map((row: any) => {
                  if (row.id === id) {
                    return { ...row, responsible: 0 };
                  }
                  return row;
                });
              });
            }

          } catch (e) {
            console.error(e);
          }
        }


        if (!value) {
          return (
            <Button2 variant="soft" color="neutral" size='sm'
              onClick={() => { submit() }}
            >
              <Add />
            </Button2>
          )
        } else {
          return (
            <div style={{
              display: "flex",
              alignItems: "center",
            }}>
              {simpleValue}
              <span style={{
                marginLeft: "24px"
              }}>
                <Button2 variant="soft" color="neutral" size='sm'
                  onClick={() => { submit() }}
                >
                  <Add />
                </Button2>
              </span>
              <span style={{
                marginLeft: "24px"
              }}>
                <Button2 variant="soft" color="neutral" size='sm'
                  onClick={() => { cancel() }}
                >
                  <Close />
                </Button2>
              </span>
            </div>
          )
        }

      }
    },
    {
      field: "simple", headerName: "단순처리", width: 90, renderCell: (params: any) => {

        const value = params.value;
        const id = params.id;

        const submit = async () => {
          setLoading(true);

          try {

            const result: any = await postFetch("/dashboard/search/simple", {
              id: params.id
            });

            setLoading(false);

            if (result.message === "success") {
              setRows((prevRows: any) => {
                return prevRows.map((row: any) => {
                  if (row.id === params.id) {
                    return { ...row, simple: true };
                  }
                  return row;
                });
              });
            }

          } catch (e) {
            console.log(e);
          }


        }

        const cancel = async () => {
          if (!id) {
            return;
          }

          setLoading(true);

          try {

            const result: any = await postFetch("/dashboard/search/simplecancel", {
              id
            });

            setLoading(false);

            if (result.message === "success") {
              setRows((prevRows: any) => {
                return prevRows.map((row: any) => {
                  if (row.id === id) {
                    return { ...row, simple: false };
                  }
                  return row;
                });
              });
            }

          } catch (e) {
            console.error(e);
          }
        }

        if (!value) {
          return (
            <Button2 variant="soft" color="neutral" size='sm'
              onClick={() => { submit() }}
            >
              <Check />
            </Button2>
          )
        } else {
          return (
            <div style={{
              display: "flex",
              alignItems: "center",
            }}>
              단순처리사항
              <span style={{
                marginLeft: "24px"
              }}>
                <Button2 variant="soft" color="neutral" size='sm'
                  onClick={() => { cancel() }}
                >
                  <Close />
                </Button2>
              </span>
            </div>
          )
        }
      }
    },
    {
      field: "action", headerName: "처리사항", width: 80, renderCell: (params: any) => {

        const title = params.row.description;
        const selectedId = params.row.id;
        const value = params.value;

        const onClick = () => {
          setSelectedId(selectedId);
          setSelectedTitle(title);
          toggleDrawer(true);
        }

        return (
          <div style={{
            display: "flex",
            alignItems: "center",
            width: "30px",
            justifyContent: value ? "space-between" : "center",
            cursor: "pointer"
          }}
            onClick={() => {
              onClick();
            }}
          >
            {
              value
                ?
                <span style={{
                  color: "#6d6e6f"
                }}>
                  {value}
                </span>
                :
                null
            }
            {
              value
                ?
                <Comment
                  style={{
                    width: "16px",
                    height: "16px",
                  }}
                />
                :
                "-"
            }

          </div>
        )


      },
      sortable: false
    },
    { field: 'kind', headerName: '종류', width: 60 },
    { field: 'name', headerName: '신청자', width: 100 },
    { field: 'location', headerName: '호점', width: 100 },
    { field: 'description', headerName: '내용', width: 150, renderCell: renderCellExpand },
    { field: 'date', headerName: '신청일', width: 180 },
    { field: 'status', headerName: '처리현황', type: 'singleSelect', valueOptions: ["미확인", "확인", "처리완료"], editable: true, width: 100 },
    { field: 'firstReply', headerName: '확인답변', width: 150, editable: true, renderCell: renderCellExpand },
    { field: 'secondReply', headerName: '완료답변', width: 150, editable: true, renderCell: renderCellExpand },
    { field: 'over', headerName: '경과일', width: 100 },
    {
      field: 'image', headerName: '사진', width: 50, renderCell: (params) => {

        const id = params.row.id;
        const userId = params.row.userId;

        if (params.value) {

          return (
            <div
              onClick={(e: any) => {
                setImageSrc(params.value);
                setOpen5(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                cursor: "pointer"
              }}>
              <ImageIcon color="success" />
            </div>
          )

        } else {
          return (
            <div style={{
            }}>
                -
            </div>
          )
        }

      }
    },
    {
      field: 'image2', headerName: '사진', width: 50, renderCell: (params) => {

        const id = params.row.id;
        const userId = params.row.userId;

        if (params.value) {

          return (
            <div
              onClick={(e: any) => {
                setImageSrc(params.value);
                setOpen5(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                cursor: "pointer"
              }}>
              <ImageIcon color="success" />
            </div>
          )

        } else {
          return (
            <div style={{
            }}>
                -
            </div>
          )
        }

      }
    },
    {
      field: 'image3', headerName: '사진', width: 50, renderCell: (params) => {

        const id = params.row.id;
        const userId = params.row.userId;

        if (params.value) {

          return (
            <div
              onClick={(e: any) => {
                setImageSrc(params.value);
                setOpen5(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                cursor: "pointer"
              }}>
              <ImageIcon color="success" />
            </div>
          )

        } else {
          return (
            <div style={{
            }}>
                -
            </div>
          )
        }

      }
    },
  ];


  useEffect(() => {
    setLoading(true);
    async function start() {
      var token = "";
      if (window.electron) {
        token = await window.electron.sendMessageApi.getToken();
      }

      fetch(`https://peetsunbae.com/dashboard/search/totalopinion`, {
        method: "GET",
        headers: { "Authorization": token },
        credentials: "include",
      }).then((response: any) => {
        response.json()
          .then((result: any) => {

            if (result.data) {
              const newRows: any = [];
              result.data.forEach((each: any) => {
                const oneRow: any = {}
                oneRow.id = each.id;
                oneRow.name = each.named === "named" ? each.name : "익명";

                var text = "";

                opinionKinds.forEach((kind) => {
                  if (kind.value === each.kindValue) {
                    text = kind.lable;
                  }
                })

                oneRow.kind = text;

                // switch (each.kindValue) {
                //     case "live":
                //         oneRow.kind = "생활";
                //         break;
                //     case "change":
                //         oneRow.kind = "자리변경";
                //         break;
                //     case "consult":
                //         oneRow.kind = "담임상담";
                //         break;
                //     case "question":
                //         oneRow.kind = "질의응답";
                //         break;
                //     case "coaching":
                //         oneRow.kind = "과외";
                //         break;
                //     case "ceo":
                //         oneRow.kind = "대표에게";
                //         break;
                //     case "etc":
                //         oneRow.kind = "기타";
                //         break;
                // }
                oneRow.location = each.location;
                oneRow.action = each.chatCount;
                oneRow.description = each.description;
                oneRow.responsible = each.responsibleName;
                const date = new Date(each.createdAt);
                oneRow.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours() > 11 ? "오후" : "오전"} ${date.getHours() > 12 ? date.getHours() - 12 : date.getHours()}시 ${date.getMinutes()}분`;
                oneRow.image = each.images.length > 0 ? `https://peetsunbae.com/${each.images[0].split("/public/")[1]}` : ""
                oneRow.image2 = each.images.length > 1 ? `https://peetsunbae.com/${each.images[1].split("/public/")[1]}` : ""
                oneRow.image3 = each.images.length > 2 ? `https://peetsunbae.com/${each.images[2].split("/public/")[1]}` : ""
                oneRow.status = each.status;
                oneRow.firstReply = each.firstReply;
                oneRow.simple = each.simple;
                if (each.firstReplyAuthor) {
                  oneRow.firstReply += " (" + each.firstReplyAuthor + ")";
                }
                oneRow.secondReply = each.secondReply;
                if (each.secondReplyAuthor) {
                  oneRow.secondReply += " (" + each.secondReplyAuthor + ")";
                }

                oneRow.over = Math.floor((new Date().getTime() - new Date(each.createdAt).getTime()) / 86400000) + "일"
                newRows.push(oneRow);
              });
              setRows([...newRows]);
            }
            setLoading(false);
          })
      })
    }

    start();
  }, [update]);

  const handleCommit = async (newRow: any, old: any) => {

    var field = "";


    for (const [key, value] of Object.entries(newRow)) {
      if (value !== old[key]) {
        field = key;

      }
    }

    const id = newRow.id;
    const value = newRow[field];


    var token = "";
    if (window.electron) {
      token = await window.electron.sendMessageApi.getToken();
    }

    fetch(`https://peetsunbae.com/dashboard/search/totalopinion`, {
      method: "PATCH",
      headers: { "Authorization": token, "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        id, field, value
      })
    }).then((response: any) => {
      response.json()
        .then((result: any) => {

          setLoading(false);
        })
    })

    return newRow;
  }

  const handleProcessRowUpdateError = React.useCallback((error: Error) => {

    alert(error.message);
  }, []);

  const handleChange = (e: any, newAlignment: string) => {

    if (!newAlignment) {
      return;
    }

    setAlignment(newAlignment);

    const newFilterModel: any = { ...filterModel };

    newFilterModel.items.forEach((each: any) => {

      if (newAlignment === "전체") {

        if (each.id === 2) {
          each.value = "";
        }

      } else {
        if (each.id === 2) {
          each.value = newAlignment;
        }
      }


    })

    setFilterModel(newFilterModel);

  }

  const toggleDrawer = (open: boolean) => {
    setOpen3(open);
  }



  return (
    <div>
      <div className={styles.mysearchDate} style={{
        width: "1500px"
      }}>
        <div>
          처리현황 변경시 꼭! 확인답변, 완료답변에 상세내용 적어주세요. 학생한테 전달됩니다.
        </div>
        <div>
          {new Date().getFullYear()}-{new Date().getMonth() + 1}-{new Date().getDate()}
        </div>
      </div>
      <div style={{
        marginTop: "12px",
        marginBottom: "12px",
      }}>
        <ToggleButtonGroup
          color="primary"
          value={alignment}
          exclusive
          onChange={handleChange}
        >
          {
            props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {
              return (
                <ToggleButton value={each.korean} key={index}>{each.korean}</ToggleButton>
              )
            })
          }
        </ToggleButtonGroup>
      </div>
      <div className={classes.root} style={{ height: 900, width: 1500, backgroundColor: "white" }}>
        <DataGridPremium loading={loading} rows={rows} columns={columns}
          density="compact"
          components={{ Toolbar: GridToolbar }}
          getRowClassName={(params) =>
            `super-app-theme--${params.row.status}`
          }
          //onCellEditCommit={handleCommit}
          //disableSelectionOnClick={true}
          processRowUpdate={handleCommit}
          onProcessRowUpdateError={handleProcessRowUpdateError}
          disableRowSelectionOnClick={true}
          filterModel={filterModel}
          onFilterModelChange={(model) => {
            setFilterModel(model);
          }}
        />
      </div>
      <div className={styles.mysearchDescription}>
        * 처리현황은 (미확인, 확인, 처리완료) 세단계로 표기됩니다.<br />
        * 경과일은 작성시간 기준 24시간마다 1일이 증가합니다.
      </div>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading2}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <SwipeableDrawer
        anchor="right"
        open={open3}
        onClose={() => {
          toggleDrawer(false);
          setSelectedTitle("");
          setSelectedId(0);
        }}
        onOpen={() => { toggleDrawer(true); }}
      >
        <div
          style={{ width: "550px", height: "100%" }}
          role="presentation"
          className={styles.todoChat}
        // onClick={(e) => { toggleDrawer(false) }}
        // onKeyDown={(e) => { toggleDrawer(false) }}
        >
          <ChatForOpinion handleUpdate2={() => { }} handleUpdate={() => { }} openControl={open3} user={props.user} studentName={selectedTitle} chatRoomId={(selectedId) ? selectedId : 0} unreadMessage={() => { }} />
        </div>
      </SwipeableDrawer>

      <ImageModal2
        open={open5}
        handleClose={() => { setOpen5(false) }}
        src={[imageSrc]}
        isMultiple={false}
      />

    </div>
  )
}

export default Totalsearch;